import { PlayListModel } from "../schema/playlist.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class PlayListContainer extends MongoBaseContainer{
    playlist: PlayListModel;
}